import { useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import Popup from 'reactjs-popup';
import cx from 'classnames';
import Button from 'react-bootstrap/Button';
import Accordion from '@components/@core/Accordion';
import CheckBox from '@components/@core/CheckBox';
import Dropdown from '@components/@core/Dropdown';
import Search from '@components/@core/Search';
import VendorActions from '~/actions/vendor';
import { SearchSections, SearchOptions } from '~/services/config';

function SearchBox() {
    const dispatch = useDispatch();
    const ref = useRef();
    const [search, setSearch] = useState('');
    const [searchOption, setSearchOption] = useState('exact');

    const handleSearch = () => {
        closeSearchModal();
        if (search === '') return;
        const payload = { search, how_to_search: searchOption };
        const route = {
            pathname: '/vendor-ratings/search',
            param: { search },
        };
        dispatch(VendorActions.globalsearchRequest(payload, null, route));
    };
    const handleChangeSearch = (e) => {
        setSearch(e.target.value);
    };
    const handleChangeSearchOption = (v) => (e) => {
        e.preventDefault();
        setSearchOption(v);
    };
    const handleSearchKeyDown = (e) => {
        if (e.key === 'Enter' && search !== '') handleSearch();
    };
    const closeSearchModal = () => ref.current.close();

    return (
        <Popup className="searchbox" arrow={false} position="bottom right" ref={ref} trigger={(open) => <div className={cx('search truncate-one text-400', open && 'active')}>Search</div>}>
            <div className="d-h-start p-0 p-md-4 flex-column flex-md-row ps-2 ps-md-0">
                <Search className="search-input" placeholder="Socket" hideIcon onChange={handleChangeSearch} onKeyDown={handleSearchKeyDown} />
                <Button className="search-button mt-2 mt-md-0 ms-0 ms-md-1" onClick={handleSearch}>
                    SEARCH
                </Button>
            </div>
            <Accordion className="search-container" icon={null} expanded title="More filters">
                <Dropdown
                    className="section-dropdown ms-0"
                    width="fit-content"
                    title="Select section to search in"
                    placeholder="Select a section"
                    direction="vertical"
                    defaultIds={[1]}
                    returnBy="data"
                    data={SearchSections}
                />
                <p className="dsl-m12 mt-3 mb-2">How to search</p>
                <div className="d-h-between flex-column flex-md-row">
                    {SearchOptions.map((option) => {
                        const checked = searchOption === option.value;
                        return (
                            <div className="d-h-start my-2 my-md-0" key={option.id} onClick={handleChangeSearchOption(option.value)}>
                                <CheckBox id={option.id} size="tiny" checked={checked} />
                                <p className="dsl-b14 mb-0 ms-2">{option.label}</p>
                            </div>
                        );
                    })}
                </div>
            </Accordion>
        </Popup>
    );
}

export default SearchBox;
